// extracted by mini-css-extract-plugin
module.exports = {"group":"RXtS2cQs"};